import React, { useEffect, useState } from 'react';
import icon1 from '../assets/icon1.png';

const SplashScreen = ({ onFinish }) => {
  const [stage, setStage] = useState('entering'); // entering, waiting, exiting, done

  useEffect(() => {
    // 1. Enter (smooth reveal with blur and scale) - 800ms
    const enterTimer = setTimeout(() => {
      setStage('waiting');
    }, 800);

    // 2. Wait for 1.4 seconds (gives time to appreciate the logo)
    const waitTimer = setTimeout(() => {
      setStage('exiting');
    }, 2200);

    // 3. Exit (graceful fade out and expand) - 800ms
    const exitTimer = setTimeout(() => {
      setStage('done');
      if (onFinish) onFinish();
    }, 3000);

    return () => {
      clearTimeout(enterTimer);
      clearTimeout(waitTimer);
      clearTimeout(exitTimer);
    };
  }, [onFinish]);

  if (stage === 'done') return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#FAFAFA] dark:bg-[#050505] transition-opacity duration-[800ms] ease-in-out ${
        stage === 'exiting' ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="relative flex flex-col items-center justify-center px-6 md:px-12 w-full max-w-4xl mx-auto">
        
        {/* Main Logo */}
        <img 
          src={icon1} 
          alt="TankCare Logo" 
          className={`h-16 sm:h-20 md:h-24 lg:h-28 w-auto object-contain transition-all duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] transform ${
            stage === 'entering' 
              ? 'scale-90 opacity-0 blur-md translate-y-4' 
              : stage === 'exiting' 
                ? 'scale-110 opacity-0 blur-lg -translate-y-4' 
                : 'scale-100 opacity-100 blur-0 translate-y-0'
          }`} 
        />
        
        {/* Luxury Subtitle (Fades in slightly after the logo) */}
        <div 
          className={`absolute -bottom-10 md:-bottom-12 overflow-hidden transition-all duration-[1000ms] delay-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${
            stage === 'entering' 
              ? 'opacity-0 translate-y-2' 
              : stage === 'exiting' 
                ? 'opacity-0 translate-y-4' 
                : 'opacity-100 translate-y-0'
          }`}
        >
          <span className="font-label-sm text-[9px] md:text-[11px] text-surface-variant dark:text-surface-variant/70 uppercase tracking-[0.35em] md:tracking-[0.5em] font-medium whitespace-nowrap">
            Premium Aquatic Hygiene
          </span>
        </div>

      </div>
    </div>
  );
};

export default SplashScreen;